const getters = {
    countries: state => state.countries,
    zipCodes: state => state.zipCodes
}

export default getters;